// The Wi-Fi + Bluetooth HUB (ESP32BLEGATEWAY, DeviceID 103 — docs/20) where it
// IS drawn: the admin tools (Device Admin, MQTT console, Device Tracking) and
// its own device page. The user screens never show it (core/devices/hubDevice).
//
// ⚠️ NO BUTTONS. Registration gave the hub four OutputDetails rows like any
// other device, so the generic card drew S1–S4 + All On / All Off — switches
// that switch nothing. The DeviceID decides the controls, never the rows.
// What the hub has is a state: live (answers MESHPING), keys or not.

import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import HubIcon from '@mui/icons-material/Hub';
import { useApp } from '../../core/state/AppContext';
import { watchHub, offlineSinceText } from '../../core/ble/mesh/hubStatus';

function useHubLive(uno) {
  const { userId } = useApp();
  const [st, setSt] = useState({ live: undefined, ready: undefined, lastLiveAt: null });
  useEffect(() => watchHub(uno, userId, setSt), [uno, userId]);
  return st;
}

/** The body: what the hub is and whether it is live. `compact` for a card. */
export default function HubInfo({ device, compact = false }) {
  const st = useHubLive(device?.UniqueNumber);
  let line;
  let color;
  if (st.live === undefined) { line = 'Checking…'; color = 'text.secondary'; }
  else if (!st.live) {
    const since = offlineSinceText(st.lastLiveAt);
    line = `Offline${since ? ` ${since}` : ''}`;
    color = '#ef5350';
  } else if (st.ready === false) { line = 'Online — no mesh keys for this location yet'; color = '#ffa726'; }
  else { line = 'Online — carrying commands to the Bluetooth lamps'; color = '#66bb6a'; }

  return (
    <Box sx={{
      display: 'flex', gap: 1.25, alignItems: 'flex-start', p: compact ? 0 : 2,
    }}
    >
      <HubIcon sx={{ fontSize: compact ? 28 : 40, color: 'text.secondary', mt: 0.25 }} />
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={{ fontWeight: 700, color, fontSize: compact ? 12 : 15 }}>{line}</Typography>
        <Typography color="text.secondary" sx={{ fontSize: compact ? 11 : 14, mt: 0.25 }}>
          Wi-Fi + Bluetooth hub. It relays the app&apos;s commands to the BLE WWH lamps at this
          location and has no buttons of its own.
        </Typography>
      </Box>
    </Box>
  );
}
